import { Avatar, Typography, Dropdown, Divider, Button } from "antd";
import React, { useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";

//
//component
//redux
//selector
//actions
import { logOut as logoutUser } from "store/user/auth/user_auth.action";
import { logOut as logOutBailiff } from "store/bailiff/auth/bailiff_auth.action";
//utils
//hook
//str
import "./header_user.css";
import {
  displayNameSelector,
  emailSelector,
  photoURLSelector,
} from "store/user/auth/user_auth.selector";
import { useSearchParams } from "react-router-dom";

const HeaderUser = () => {
  // -------------------------- VAR -----------------------------
  const [_, setSearchParams] = useSearchParams();

  // -------------------------- STATE ---------------------------
  const [open, setOpen] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const email = useSelector(emailSelector);
  const photoURL = useSelector(photoURLSelector);
  const displayName = useSelector(displayNameSelector);
  const finalName = email;
  const name = finalName?.split("@")?.[0] || "Tài khoản mới";

  // -------------------------- FUNCTION ------------------------
  const handleLogout = () => {
    dispatch(logoutUser());
    dispatch(logOutBailiff());
  };

  const handleChange = (value) => {
    setOpen(value);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  const renderDropdown = () => {
    return (
      <div className="mt-[10px] min-h-[100px] min-w-[200px] rounded-md border-[1px] !border-gray-300 bg-white p-5 shadow-md">
        <div className="flex flex-row gap-2">
          <Avatar src={photoURL} size={38} icon={<UserOutlined />} />
          <div>
            <Typography.Title
              style={{ padding: 0, margin: 0 }}
              level={5}
              ellipsis={{ rows: 1 }}
              className="cursor-pointer !underline"
              onClick={() => setSearchParams({ viewOpenAccount: true })}
            >
              {displayName || name}
            </Typography.Title>
            <div className="italic">{name}</div>
          </div>
        </div>
        <Divider />
        <Button onClick={handleLogout} block className="min-h-[50px]">
          Đăng xuất
        </Button>
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Dropdown
      placement="bottomCenter"
      trigger={["hover"]}
      open={open}
      onOpenChange={handleChange}
      className="logout-dropdown"
      popupRender={renderDropdown}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <div className="flex flex-row gap-2">
          <Avatar
            className="cursor-pointer shadow-md"
            src={photoURL}
            size="default"
            icon={<UserOutlined />}
          />
        </div>
      </div>
    </Dropdown>
  );
};
export default HeaderUser;
